module.exports = __webpack_public_path__ + "media/images/icon_offline-16f6489a.svg";